module.exports = __webpack_public_path__ + "static/media/concorde.a4f6d164.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/concorde.png
// module id = 340
// module chunks = 0